import { getActiveChannel } from '../authentication/utils'
import {get} from '../utils'

export default host => (clientId, include = 'include=featuredImage.image') =>
  get(`${host}/clients/${clientId}/channels/${getActiveChannel()}/playlists?${include}&order_by=created_at&sort_type=DESC`)
  .then(response => response.json())
  .then(json => json.data)
